import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import Circle from '../circle';
import Icon from '@material-ui/core/Icon';
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import { SingleSharers } from '../../pages/single';
export default class Intro extends React.Component{
  componentDidMount(){
    this.set();
  }

  set(){
    if(this.chevron){
      anime({
        targets: this.chevron,
        translateY: 20,
        easing: 'linear',
        loop: true,
        direction: 'alternate',
        duration: 3000,
      })
    }
  }

  render(){
    var p = {
      title: 'Ciudadanos indefensos en el día a día'
    }

    return(
      <div className="page fullpage" id="intro">
        <Circle />
        <div className="page_container">
          <div className="page_h1">
            <img src={require('../../static/logo_h.png')} className="mobile_noshow"/>
            <img src={require('../../static/logo.png')} className="desktop_noshow"/>
          </div>
          {
            !this.props.hideIntro ?
            <div className="page_intro">
              ¿Quién no se ha peleado con un vecino? Sea porque ocupa el lugar de estacionamiento que no le corresponde, porque hace mucho ruido o porque no pone la basura en su lugar.
              <br/><br/>
              ¿Quién no ha escuchado de los abusos de algún exesposo, que secuestró a sus hijos o que simplemente no paga pensión?
              <br/><br/>
              ¿Cuántos casos hay de trabajadores despedidos ilegalmente, que deben esperar años a que se resuelvan sus demandas?
              <br/><br/>
              ¿Y quién ha logrado que le hagan justicia?
              <br/><br/>
              En México, la mitad de la población ha sido víctima en casos parecidos.
              <br/><br/>
              Y el número de personas que lo ha resuelto, que ha obtenido justicia es una minoría: apenas el 10%.
            </div>
            : null
          }

          <div className="page_ctas">
            <Link smooth to="interactivo">
            <div className="page_ctas_cta">
              Ir al interactivo
            </div>
            </Link>
          </div>
          <div id="intro_sharers">
            <SingleSharers p={p}/>
          </div>
        </div>
        <Link to="first" spy={true} smooth={true} duration={1000}>
          <div id="page_scrolldown">
            <Icon ref={(ref) => this.chevron = ref}>keyboard_arrow_down</Icon>
          </div>
        </Link>
      </div>
    )
  }
}
